import type { AnyAction } from '@reduxjs/toolkit';
import {
  setAdditionalRequirements,
  setComplianceRequirements,
  setDeliveryLocation,
  setLeadTime,
  setSourcingLocation,
  setSupplierPriority,
} from '../store/rfqSlice';
import { complianceFromBackend, leadTimeFromBackend, prioritiesFromBackend } from './sourcingCriteria';
import type { CriteriaChanges } from '../types/robbieProposal';

/** The requirements the server saved, as PATCH /requirements returns them. */
export interface SavedRequirements {
  deliveryLocation?: { formattedAddress?: string };
  sourcingLocation?: string;
  desiredLeadTime?: string;
  notes?: string;
  complianceRequirements?: string[];
  tradeoffPriorities?: string[];
}

/**
 * The store actions that put an applied criteria card into the step-2 form —
 * only for the fields the card named, read back from what the server saved
 * (so the form shows the stored spelling, e.g. a lead-time preset).
 */
export const criteriaDraftActions = (changes: CriteriaChanges, saved: SavedRequirements): AnyAction[] => {
  const actions: AnyAction[] = [];
  if (changes.deliveryLocation !== undefined) actions.push(setDeliveryLocation(saved.deliveryLocation?.formattedAddress || ''));
  if (changes.sourcingLocation !== undefined) actions.push(setSourcingLocation(saved.sourcingLocation || ''));
  if (changes.desiredLeadTime !== undefined) actions.push(setLeadTime(leadTimeFromBackend(saved.desiredLeadTime)));
  if (changes.notes !== undefined) actions.push(setAdditionalRequirements(saved.notes || ''));
  if (changes.addCompliance || changes.removeCompliance) {
    actions.push(setComplianceRequirements(complianceFromBackend(saved.complianceRequirements)));
  }
  if (changes.tradeoffPriorities !== undefined) {
    actions.push(setSupplierPriority(JSON.stringify(prioritiesFromBackend(saved.tradeoffPriorities))));
  }
  return actions;
};
